const data = {
  info: 'Innovative, task-driven, professional app and web developer . Proficient in developing databases, writing and testing codes, trouble shooting simple/complex issue, Implementing new features based on user feedback',
  projects: [
    {
      id: 1,
      title: 'SAP Management',
      description:
        "It's a Mobile application developed in flutter for college Students ",
      link: '',
      img: 'images/MYKEC.png',
    },
    {
      id: 2,
      title: 'CANVAS ',
      description: "It's a web game developed using JS ",
      link: 'https://leetcode.com/problemset/all/',
      img: 'images/jsgame.jpg',
    },
    {
      id: 3,
      title: 'AMAZONA',
      description:
        "It's a Web application developed using MERN STACK as an Ecommerce website ",
      link: 'https://leetcode.com/problemset/all/',
      img: 'images/amazona.jpg',
    },
  ],
  education: [
    {
      year: '2018',
      info: 'Secured 92.6%',
      place: 'Saratha Matric Higher Secondary School',
      dis: 'Gobi,Erode',
    },
    {
      year: '2020',
      info: 'Secured 90%',
      place: 'Saratha Matric Higher Secondary School',
      dis: 'Gobi,Erode',
    },
    {
      year: '2020-2024',
      info: 'Computer Science and Engineering(6th semester)',
      place: 'Kongu Engineering College',
      dis: 'Perundurai',
    },
  ],
  services: [
    {
      name: 'frontend',
      des: [
        'A front-end design takes on the task of engaging visitors so that businesses and organizations can reap the benefits of an online presence',
        'In today’s interactive world, it isn’t enough to create a user-friendly interface',
        'A web design must also drive sales and conversions',
        'It should responsive to how every visitor interacts with a site',
        'They are action oriented, easy for the user to engage with, and help a company or website collect valuable information',
      ],
    },
    {
      name: 'backend',
      des: [
        'A Backend should be both effective and efficient, enabling customers to be satisfied with their experience of using your website or app',
        'It enables businesses to create customized web experiences for their customers',
        'It can help businesses meet their compliance requirements',
        'It allows for seamless integration between different web technologies',
        'A great user experience is now essential if you want to succeed online, and this can be achieved through backend development',
      ],
    },
    {
      name: 'App development',
      des: [
        'As part of the development process, mobile user interface (UI) design is also essential in the creation of mobile apps',
        'Mobile App Strategy refers to the creative effort required to translate consumer’s needs into an app',
        'It should be same as the website to achieve the business goals',
        'It can be used seamlessly to accomplish a specific task',
        'Easily create rich and engaging mobile apps and publish them effortlessly on the Apple Store or Google Play',
      ],
    },
  ],
  myskill: {
    frontend: [
      {
        name: 'html5',
        level: '90%',
      },
      {
        name: 'css',
        level: '70%',
      },
      {
        name: 'js',
        level: '70%',
      },
      {
        name: 'Flutter',
        level: '85%',
      },
      {
        name: 'React',
        level: '65%',
      },
    ],
    backend: [
      {
        name: 'nodejs',
        level: '80%',
      },
      {
        name: 'mongodb',
        level: '80%',
      },
      {
        name: 'php',
        level: '50%',
      },
      {
        name: 'mysql',
        level: '50%',
      },
    ],
    coding: [
      {
        name: 'java',
        level: '85%',
      },
      {
        name: 'c',
        level: '70%',
      },
      {
        name: 'python',
        level: '75%',
      },
      {
        name: 'dart',
        level: '80%',
      },
    ],
  },
};

export default data;
